export enum SEARCH_PAGE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=75724433
     */
    DID_YOU_MEAN = 'FRONT.SEARCH.DID_YOU_MEAN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=76735352
     */
    PROMOTED_RESULTS = 'FRONT.SEARCH.PROMOTED_RESULTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=76735374
     */
    OTHER_RESULTS = 'FRONT.SEARCH.OTHER_RESULTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=96816087
     */
    RESULTS_TITLE = 'FRONT.SEARCH.RESULTS_TITLE',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=209919538 */
    EXTENSION__GLOBAL_ERROR = 'SEARCH.EXTENSION_GLOBAL_ERROR',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=209922791 */
    EXTENSION__GLOBAL_ERROR_DESCRIPTION = 'SEARCH.EXTENSION__GLOBAL_ERROR_DESCRIPTION',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=264705961 */
    EXTENSION__EXTENSION_ERROR_TITLE = 'SEARCH.EXTENSION_MARKETPLACE_ERROR_TITLE',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=264705980 */
    EXTENSION__EXTENSION_ERROR_DESC = 'SEARCH.EXTENSION_MARKETPLACE_DESC',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=264705995 */
    EXTENSION__FETCH_ERROR_TITLE = 'SEARCH.EXTENSION_FETCH_ERROR_TITLE',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=264706021 */
    EXTENSION__FETCH_ERROR_DESC = 'SEARCH.EXTENSION_FETCH_ERROR_DESC',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=677540410 */
    EXTENSION__CONNECTOR_ERROR_DESC = 'SEARCH.EXTENSION_CONNECTOR_ERROR_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536811952
     */
    FEEDBACK_SUBTITLE = 'SEARCH.FEEDBACK_SUBTITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536811945
     */
    FEEDBACK_TITLE = 'SEARCH.FEEDBACK_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=595139577
     */
    FEEDBACK_COMMENT = 'SEARCH.FEEDBACK_COMMENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=613393494
     */
    SEARCH_RESULTS_FOR = 'SEARCH_PAGE.SEARCH_RESULTS_FOR',
}
